module.exports = __webpack_public_path__ + "media/images/logo-0c93b110cd99bc81a6e0aad5da79a06a.png";